import type { ReactNode } from 'react'
import { WppAccordion, WppLabel, WppTypography } from '@wppopen/components-library-react'
import styles from './FormAccordionSection.module.scss'

interface FormAccordionSectionProps {
  isFormActive?: boolean
  text: string
  tooltip?: string
  halfWidthChildren?: ReactNode
  fullWidthChildren?: ReactNode
}

export default function FormAccordionSection({
  text,
  tooltip,
  halfWidthChildren,
  fullWidthChildren,
}: FormAccordionSectionProps) {
  return (
    <WppAccordion
      size="m"
      withDivider={false}
      expanded
      data-testid="form-section-accordion"
      className={styles.accordion}
    >
      {tooltip ? (
        <WppLabel
          config={{
            text,
            icon: tooltip ? 'wpp-icon-info' : undefined,
            description: tooltip,
          }}
          slot="header"
          typography="s-strong"
          className={styles.label}
        />
      ) : (
        <WppTypography type="s-strong" slot="header">
          {text}
        </WppTypography>
      )}

      <div className={styles.container}>
        {halfWidthChildren && (
          <div className={styles.halfWidth} data-testid="half-container">
            {halfWidthChildren}
          </div>
        )}
        {fullWidthChildren}
      </div>
    </WppAccordion>
  )
}
